import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { NavigationCancel, NavigationEnd, NavigationError, NavigationStart, Router } from '@angular/router';
import DxCalendar, { Properties as DxCalendarProperties } from 'devextreme/ui/calendar';
import { SplashScreenService } from '@core/modules/splash-screen/splash-screen.service';
import { Subscription } from 'rxjs';

import { DailyPlanListenerService } from '@app/shared/modules/time-tracker/daily-plan-listener.service';
import { FrontedVersionCheckService } from '@core/services/frontend-version-check.service';
import { NavigationProgressService } from '@services/navigation-progress.service';
import { TitleService } from '@services/title.service';
import { TranslationService } from '@services/translation.service';
import { UserViewSettingsService } from '@services/user-view-settings.service';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'body[pps-root]',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false,
})
export class AppComponent implements OnInit, OnDestroy {
  private readonly _translationService = inject(TranslationService);
  private readonly _titleService = inject(TitleService);
  private readonly _userViewSettingsService = inject(UserViewSettingsService);
  private readonly _splashScreenService = inject(SplashScreenService);
  private readonly _navigationProgressService = inject(NavigationProgressService);
  private readonly _router = inject(Router);
  private readonly dailyPlanListenerService = inject(DailyPlanListenerService);

  private unsubscribe: Subscription[] = [];
  private readonly _frontedVersionCheckService = inject(FrontedVersionCheckService);

  constructor() {
    this.setDevExtremeDefaultOptions();

    this._router.events.subscribe(event => {
      if (event instanceof NavigationError) {
        if (
          event.error?.message?.includes('ChunkLoadError') ||
          event.error?.message?.includes('Failed to fetch dynamically imported module')
        ) {
          console.warn(event, 'Lazy-loaded chunk failed. Reloading page.');
          window.location.reload();
        }
      }
    });
  }

  ngOnInit() {
    const routerSubscription = this._router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        this._navigationProgressService.changeIsInProgress(true);
      } else if (event instanceof NavigationEnd) {
        this._navigationProgressService.changeIsInProgress(false);

        this._splashScreenService.hide();
        window.scrollTo(0, 0);
      } else if (event instanceof NavigationCancel) {
        this._navigationProgressService.changeIsInProgress(false);
      }
    });
    this.unsubscribe.push(routerSubscription);
  }

  ngOnDestroy() {
    this.unsubscribe.forEach(sb => sb.unsubscribe());
  }

  private setDevExtremeDefaultOptions(): void {
    DxCalendar.defaultOptions<DxCalendarProperties>({
      options: {
        showWeekNumbers: true,
      },
    });
  }
}
